module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/1WYAjZ8QTyC4QgMSgo0QsO-ad6626f64d67dcb87f7651d6fe41ebbd.jpg";